







































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Inject } from 'inversify-props'
import SeletorDeLojas from '@/components/loja/SeletorDeLojas.vue'
import type { LojaServiceAdapter, MarketplaceServiceAdapter } from '@/usecases'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import DataTableDeCrud from '@/components/ui/DataTableDeCrud.vue'
import { ConfiguracoesMarketplace } from '@/models'
import { uploadFilesToS3 } from '@/shareds/s3/files'
import { formatDataImportacaoToBrWithTimezone } from '@/shareds/date/date-utils'
import SeletorDeTabelaDePreco from '@/components/tabeladepreco/SeletorDeTabelaDePreco.vue'
@Component({
	components: {
		SeletorDeLojas,
		DataTableDeCrud,
		SeletorDeTabelaDePreco,
	},
})
export default class TelaDeConfiguracoesMarketplace extends Vue {
	carregandoConfigsMarketplace = false
	filtroDeLojas: any[] = []
	configuracoesMarketplace: ConfiguracoesMarketplace | null = null
	mostrarDialogoDeProduto = false
	confirmandoLogin = false
	salvando = false
	primeiroAcesso = true
	refreshToken: string | null = null
	arquivoDeCores: File | null = null
	arquivoDeTamanhos: File | null = null
	arquivoDeCategorias: File | null = null
	importandoCores = false
	importandoTamanhos = false
	importandoCategorias = false

	@Inject('LojaServiceAdapter')
	lojaService!: LojaServiceAdapter

	@Inject('MarketplaceServiceAdapter')
	marketplaceService!: MarketplaceServiceAdapter

	get dataImportacaoCoresFormatada(): string {
		return formatDataImportacaoToBrWithTimezone(this.configuracoesMarketplace?.dataImportacaoCores || null)
	}

	get dataImportacaoTamanhosFormatada(): string {
		return formatDataImportacaoToBrWithTimezone(this.configuracoesMarketplace?.dataImportacaoTamanhos || null)
	}

	get dataImportacaoCategoriasFormatada(): string {
		return formatDataImportacaoToBrWithTimezone(this.configuracoesMarketplace?.dataImportacaoCategorias || null)
	}

	@Watch('filtroDeLojas')
	async aplicarFiltro() {
		this.carregandoConfigsMarketplace = true
		try {
			if (!this.filtroDeLojas) {
				this.configuracoesMarketplace = null
				this.carregandoConfigsMarketplace = false
				return
			}

			if (typeof this.filtroDeLojas === 'string') {
				this.configuracoesMarketplace = await this.marketplaceService.findConfiguracoesPorLoja(this.filtroDeLojas)

				if(!this.configuracoesMarketplace.isConfigurado) {
					this.primeiroAcesso = true
				} else this.primeiroAcesso = false
			}

		} catch (e) {
			AlertModule.setError(e)
		} finally {
			this.carregandoConfigsMarketplace = false
		}
	}
	
	async confirmarLogin() {
		if (!this.configuracoesMarketplace) return
		this.confirmandoLogin = true
		try {
			this.configuracoesMarketplace = await this.marketplaceService.validarTokenParaLogin(this.configuracoesMarketplace)
			this.primeiroAcesso = false
		} catch(error) {
			AlertModule.setError(error)
		} finally {
			this.confirmandoLogin = false
		}
	}

	async salvar() {
		this.salvando = true
		if (!this.configuracoesMarketplace) return

		try {
			if (this.refreshToken && this.refreshToken.length > 0) {
				this.configuracoesMarketplace.refreshToken = null
				this.configuracoesMarketplace.tokenDeAcesso = null

				await this.marketplaceService.validarRefreshToken(this.configuracoesMarketplace.id, this.refreshToken)
				this.refreshToken = null

				AlertModule.setSuccess('Token de renovação atualizado com sucesso')

				this.configuracoesMarketplace = await this.marketplaceService.updateConfiguracao(this.configuracoesMarketplace)
			} else {
				this.configuracoesMarketplace = await this.marketplaceService.updateConfiguracao(this.configuracoesMarketplace)
				AlertModule.setSuccess('Configuração salva com sucesso')
			}
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
		}
	}

	async validarTokenParaLogin() {
		if (!this.configuracoesMarketplace) return 
		return await this.marketplaceService.validarTokenParaLogin(this.configuracoesMarketplace)
	}

	async confirmarImportacaoCores() {
		if (!this.configuracoesMarketplace) return
		if (!this.arquivoDeCores) return
		if (typeof this.filtroDeLojas !== 'string') return

		try {
			this.importandoCores = true

			const informacoesDosArquivos = await uploadFilesToS3([this.arquivoDeCores], `importacao-marketplace`)

			const arquivosComExtensao = informacoesDosArquivos.map(
				({ config }) => config.url?.split("?")[0] || "",
			).filter(url => url && url.length > 0)

			const dataHoraUpdate = await this.marketplaceService.importarArquivoConfiguracao({
				urlArquivo: arquivosComExtensao[0],
				tipo: 'CORES',
				lojaId: this.filtroDeLojas,
			})
			
			this.configuracoesMarketplace.dataImportacaoCores = dataHoraUpdate
			this.arquivoDeCores = null
			AlertModule.setSuccess('Arquivo importado com sucesso')
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.importandoCores = false
		}
	}

	async confirmarImportacaoTamanhos() {
		if (!this.configuracoesMarketplace) return
		if (!this.arquivoDeTamanhos) return
		if (typeof this.filtroDeLojas !== 'string') return

		try {
			this.importandoTamanhos = true

			const informacoesDosArquivos = await uploadFilesToS3([this.arquivoDeTamanhos], `importacao-marketplace/`)

			const arquivosComExtensao = informacoesDosArquivos.map(
				({ config }) => config.url?.split("?")[0] || "",
			).filter(url => url && url.length > 0)

			const dataHoraUpdate = await this.marketplaceService.importarArquivoConfiguracao({
				urlArquivo: arquivosComExtensao[0],
				tipo: 'TAMANHOS',
				lojaId: this.filtroDeLojas,
			})
			
			this.configuracoesMarketplace.dataImportacaoTamanhos = dataHoraUpdate
			this.arquivoDeTamanhos = null
			AlertModule.setSuccess('Arquivo importado com sucesso')
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.importandoTamanhos = false
		}
	}

	async confirmarImportacaoCategorias() {
		if (!this.configuracoesMarketplace) return
		if (!this.arquivoDeCategorias) return
		if (typeof this.filtroDeLojas !== 'string') return

		try {
			this.importandoCategorias = true

			const informacoesDosArquivos = await uploadFilesToS3([this.arquivoDeCategorias], `importacao-marketplace/`)

			const arquivosComExtensao = informacoesDosArquivos.map(
				({ config }) => config.url?.split("?")[0] || "",
			).filter(url => url && url.length > 0)

			const dataHoraUpdate = await this.marketplaceService.importarArquivoConfiguracao({
				urlArquivo: arquivosComExtensao[0],
				tipo: 'CATEGORIAS',
				lojaId: this.filtroDeLojas,
			})
			
			this.configuracoesMarketplace.dataImportacaoCategorias = dataHoraUpdate
			this.arquivoDeCategorias = null
			AlertModule.setSuccess('Arquivo importado com sucesso')
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.importandoCategorias = false
		}
	}
}
